module.exports = __webpack_public_path__ + "img/social-linkedin.e5fc058.svg";